export * from './document.component';
export * from './drawing.component';
export * from './photo.component';

export * from './file-uploader.component';

export * from './media-thumbnail.component';
export * from './media-view-modal.component';

export * from './tag-selector.component'


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/file/index.ts